import { gql } from '@apollo/client';
export const IMPORT_FIELDS = gql `
  fragment ImportFields on Import {
    id
    createdAt
    updatedAt
    clientId
    name
    integrationConfigId
    entityType
    isActive
    isPartialFile
    lastRunStatus
    lastRunAt
    cronSchedules
    passphrase
    privateKey
    extension
    criteria
    snapshotUsingFilenameDate
    snapshotFilenamePattern
    fileDelimiter
    extraData
  }
`;
export const IMPORTS = gql `
  ${IMPORT_FIELDS}
  query IMPORTS($spec: ImportSpec!) {
    imports(spec: $spec) {
      ...ImportFields
    }
  }
`;
export const GET_IMPORT = gql `
  ${IMPORT_FIELDS}
  query GET_IMPORT($id: Int!) {
    getImport(id: $id) {
      ...ImportFields
      importFields {
        id
        createdAt
        updatedAt
        clientId
        fieldId
        sourceColumn
        valueMappings
        extraData
      }
    }
  }
`;
export const PARSE_IMPORT_FILE = gql `
  query PARSE_IMPORT_FILE(
    $clientId: Int!
    $s3Key: String!
    $existingImportFields: [ImportFieldInput!]!
    $passphrase: String
    $privateKey: String
    $extension: String
    $importId: Int
  ) {
    parseImportFile(
      clientId: $clientId
      s3Key: $s3Key
      existingImportFields: $existingImportFields
      passphrase: $passphrase
      privateKey: $privateKey
      extension: $extension
      importId: $importId
    ) {
      importFields {
        clientId
        fieldId
        sourceColumn
        valueMappings
      }
      parseImportStat {
        totalRows
        totalHeaders
      }
    }
  }
`;
export const TEST_IMPORT_DATA = gql `
  mutation TEST_IMPORT_DATA($s3Key: String!, $input: ImportInput!) {
    testImportData(s3Key: $s3Key, input: $input) {
      importId
      response {
        success
        messages {
          value
          type
          params
        }
      }
    }
  }
`;
export const SAVE_IMPORT = gql `
  ${IMPORT_FIELDS}
  mutation SAVE_IMPORT($input: ImportInput!) {
    saveImport(input: $input) {
      ...ImportFields
    }
  }
`;
export const DELETE_IMPORT = gql `
  ${IMPORT_FIELDS}
  mutation DELETE_IMPORT($id: Int!) {
    deleteImport(id: $id) {
      ...ImportFields
    }
  }
`;
export const RESUME_IMPORT = gql `
  mutation RESUME_IMPORT($id: Int!) {
    resumeImport(id: $id) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
export const REPLAY_IMPORT_RUN = gql `
  mutation REPLAY_IMPORT_RUN($id: Int!) {
    replayImportRun(id: $id) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
